import React, {Dispatch, Fragment, SetStateAction, useCallback, useMemo} from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {showEwsFwdQuestion} from 'module/SessionInfo/util/showEwsFwdQuestion';
import {Slct} from 'module/Slct/component/Slct';
import {EwsRepTO} from 'generated/JavaTO'
import {filterOptionsSlct} from 'module/Slct/util/filterOptionsSlct'
import {SlctOption} from 'module/Slct/type/SlctType'

interface Props {
	loading?: boolean
	options: Partial<EwsRepTO>[]
	ewsRep?: Partial<EwsRepTO>
	disabledFwd?: boolean
	index: number
	setEwsRepList: Dispatch<SetStateAction<EwsRepTO[]>>
}

export const EwsRepSelect = ({
	loading,
	options: _options,
	ewsRep,
	disabledFwd,
	index,
	setEwsRepList,
}: Props) => {
	const options = useMemo(() => _options.map(x => ({
		value: x.repAddress,
		label: x.displayName,
		model: x,
	})), [_options])
	const editRep = useCallback((displayName: string, repAddress: string, useFwdRule: boolean) => {
		setEwsRepList(r => r.map((x, i) =>
			i !== index ? x : {displayName, repAddress, useFwdRule},
		))
	}, [index, setEwsRepList])
	const deleteRep = useCallback(() => setEwsRepList(r => r.filter((x, i) => i !== index)), [index, setEwsRepList])
	const onChangeUseFwdRule = useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
		if (!ewsRep) return;
		if (ewsRep.repAddress && checked) {
			showEwsFwdQuestion()
				.then(() => editRep(ewsRep.displayName || '', ewsRep.repAddress || '', true))
				.catch(() => editRep(ewsRep.displayName || '', ewsRep.repAddress || '', false))
		} else {
			editRep(ewsRep.displayName || '', ewsRep.repAddress || '', false)
		}
	}, [editRep, ewsRep])
	const selectChangeHandler = useCallback((value: SlctOption<EwsRepTO, string> | null) => {
		if (value && value.model) {
			const {displayName, repAddress, useFwdRule} = value.model
			editRep(displayName, repAddress, useFwdRule)
		} else {
			deleteRep()
		}
	}, [deleteRep, editRep])
	const useFwdRule = Boolean(ewsRep && ewsRep.useFwdRule)
	return (
		<Fragment>
			<Slct
				value={ewsRep?.repAddress}
				options={options}
				onChange={selectChangeHandler}
				loading={loading}
				disabled={loading}
				showClearButton
				filterOptions={filterOptionsSlct}
			/>
			{!disabledFwd &&
				<FormControlLabel
					label={'Weiterleitungsregel bei Abwesenheit einrichten'}
					control={
						<Checkbox
							disabled={Boolean(loading || ewsRep?.repAddress?.trim() && disabledFwd)}
							checked={useFwdRule}
							onChange={onChangeUseFwdRule}
						/>
					}
				/>
			}
		</Fragment>
	)
};